import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_DISTRIBUTORPROFILE_INIT_ACTION,
  FETCH_DISTRIBUTORPROFILE_SUCCESS_ACTION,
  FETCH_DISTRIBUTORPROFILE_FAIL_ACTION,
  FETCH_DISTRIBUTORPROF_INIT_ACTION,
  FETCH_DISTRIBUTORPROF_SUCCESS_ACTION,
  FETCH_DISTRIBUTORPROF_FAIL_ACTION,
  EDIT_DISTRIBUTORPROF_INIT_ACTION,
  EDIT_DISTRIBUTORPROF_SUCCESS_ACTION,
  EDIT_DISTRIBUTORPROF_FAIL_ACTION,
  FETCH_STATES_INIT_ACTION,
  FETCH_STATES_SUCCESS_ACTION,
  FETCH_STATES_FAIL_ACTION,
  FETCH_DISTRICTBYID_INIT_ACTION,
  FETCH_DISTRICTBYID_SUCCESS_ACTION,
  FETCH_DISTRICTBYID_FAIL_ACTION,
  FETCH_BANK_INIT_ACTION,
  FETCH_BANK_SUCCESS_ACTION,
  FETCH_BANK_FAIL_ACTION,
} from "./action";

import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var history = createBrowserHistory();

function* fetchDistributorProfile(value) {
  const token = localStorage.getItem("token");
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  // For employees, fetch distributor's profile; for others, fetch their own profile
  const distributorProfId = userDetails.role === "employee" ? userDetails.distributor : userDetails.id;
  

  try {
    const res = yield fetch(`${appConfig.ip}/orgProf/` + distributorProfId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_DISTRIBUTORPROFILE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_DISTRIBUTORPROFILE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchDistributorprof() {
  const token = localStorage.getItem("token");
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  // For employees, fetch distributor's profile; for others, fetch their own profile
  const distributorProfId = userDetails.role === "employee" ? userDetails.distributor : userDetails.id;
  try {
    const res = yield fetch(`${appConfig.ip}/orgProf/` + distributorProfId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_DISTRIBUTORPROF_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_DISTRIBUTORPROF_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* EditDistributor(value) {
  // console.log(value.value.duplicateworkingHrs);
  // console.log(value.value.workingHrs);
  try {
    const token = localStorage.getItem("token");
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const distributorProfId = userDetails.id;
    if (value.value.fileimgvalue) {
      const formData = new FormData();
      // formData.append("name", "icon");
      // formData.append("icon", value.value.imgUrl, "icon");

      formData.append("attachmentType", "org-profile");
      formData.append("file", value.value.imgUrl, "name");

      const res2 = yield fetch(`${appConfig.ip}/attachments/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!res2.ok) {
        throw res2;
      } else {
        const res2JSON = yield res2.json();
        console.log(res2JSON,"nothingggggggggggg");
        console.log( value,"nothinggggggggggggjjjj");
        
        const newDtata = {
          name: value.value.name,
          contactPersn: value.value.contactPersn,
          mobile: value.value.mobile,
          state: value.value.state,
          district: value.value.district,
          email: value.value.email,
          addr1: value.value.addr1,
          addr2: value.value.addr2,
          city: value.value.city,
          landmark: value.value.landmark,
          geo: value.value.geo,
          zip: value.value.zip,
          website: value.value.website,
          licenceNo: value.value.licenceNo,
          drugLicense: value.value.licenceNo2,
          gstin: value.value.gstin,
          crdtPeriod: value.value.crdtPeriod,
          acntName: value.value.acntName,
          acntNo: value.value.acntNo,
          ifscCode: value.value.ifscCode,
          brchName: value.value.brchName,
          brchAddr: value.value.brchAddr,
          acntType: value.value.acntType,
          bankName: value.value.bankName,
          imgUrl: res2JSON.data.documentUrl,
          workingHrs: value.value.duplicateworkingHrs,
        };
        const Categry = yield fetch(
          appConfig.ip + "/orgProf/" + distributorProfId,
          {
            method: "PUT",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(newDtata),
          },
        );

       
        

        if (!Categry.ok) {
        } else {
          const categryJSON = yield Categry.json();
          yield put({
            type: FETCH_DISTRIBUTORPROFILE_INIT_ACTION,
          });
          yield put(push("/myprofile"));
          yield toast.success("Profile updated", {
            autoClose: 3000,
            transition: Flip,
          });
          yield put({
            type: EDIT_DISTRIBUTORPROF_SUCCESS_ACTION,
            payload: categryJSON,
          });
        }
      }
    } else {
      const editValue = {
        name: value.value.name,
        contactPersn: value.value.contactPersn,
        mobile: value.value.mobile,
        state: value.value.state,
        district: value.value.district,
        email: value.value.email,
        addr1: value.value.addr1,
        addr2: value.value.addr2,
        city: value.value.city,
        landmark: value.value.landmark,
        geo: value.value.geo,
        crdtPeriod: value.value.crdtPeriod,
        zip: value.value.zip,
        website: value.value.website,
        licenceNo: value.value.licenceNo,
        drugLicense: value.value.licenceNo2,
        gstin: value.value.gstin,
        acntName: value.value.acntName,
        acntNo: value.value.acntNo,
        ifscCode: value.value.ifscCode,
        brchName: value.value.brchName,
        brchAddr: value.value.brchAddr,
        acntType: value.value.acntType,
        bankName: value.value.bankName,
        imgUrl: value.value.imgUrl,
        workingHrs: value.value.duplicateworkingHrs,
      };

      const res = yield fetch(appConfig.ip + "/orgProf/" + distributorProfId, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editValue),
      });
      if (!res.ok) {
        throw res;
      } else {
        yield put({
          type: FETCH_DISTRIBUTORPROFILE_INIT_ACTION,
        });
        yield put(push("/myprofile"));
        yield toast.success("Profile updated", {
          autoClose: 3000,
          transition: Flip,
        });
        const resJSON = yield res.json();

        yield put({
          type: EDIT_DISTRIBUTORPROF_SUCCESS_ACTION,
        });
      }
    }
  } catch (err) {}
}

function* fetchStates() {
  try {
    const token = localStorage.getItem("token");

    const res = yield fetch(`${appConfig.ip}/state/all`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_STATES_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_STATES_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchDistrictById(value) {
  // console.log("value.value.value=", value);
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/districts?stateId=` + value.value,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_DISTRICTBYID_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_DISTRICTBYID_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchBank() {
  try {
    const token = localStorage.getItem("token");

    const res = yield fetch(`${appConfig.ip}/bankName/all`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_BANK_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_BANK_FAIL_ACTION,
        error: err,
      });
    }
  }
}

export function* MyProfileActionWatcher() {
  yield takeEvery(
    FETCH_DISTRIBUTORPROFILE_INIT_ACTION,
    fetchDistributorProfile,
  );
  yield takeEvery(FETCH_DISTRIBUTORPROF_INIT_ACTION, fetchDistributorprof);
  yield takeEvery(EDIT_DISTRIBUTORPROF_INIT_ACTION, EditDistributor);
  yield takeEvery(FETCH_STATES_INIT_ACTION, fetchStates);
  yield takeEvery(FETCH_DISTRICTBYID_INIT_ACTION, fetchDistrictById);
  yield takeEvery(FETCH_BANK_INIT_ACTION, fetchBank);
}
